module.exports = __webpack_public_path__ + "img/pe.pe9412c8b.svg";